import { Icon } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { formatUrl } from '../format';
import { CELL_AFFORDANCE, CellValueWithAffordance, stopCellClick } from './cellAffordance';
import { EmptyValue } from './EmptyValue';

export function UrlDisplay() {
  const { value, linkAsIcon, listRow } = useFieldContext();
  if (typeof value !== 'string' || value.length === 0) {
    return <EmptyValue />;
  }

  // In an EDITABLE cell the value is plain text and the site is one icon away (P1-8).
  if (linkAsIcon === true) {
    return (
      <CellValueWithAffordance
        affordance={
          <a
            href={value}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={`Open ${formatUrl(value)} in a new tab`}
            className={CELL_AFFORDANCE}
            onClick={stopCellClick}
          >
            <Icon name="external" size="0.85rem" />
          </a>
        }
      >
        {formatUrl(value)}
      </CellValueWithAffordance>
    );
  }

  // IN A LIST ROW THE ROW IS THE LINK (P4 round 2, finding F5): see `FieldContext.listRow`.
  if (listRow === true) {
    return <span className="block truncate">{formatUrl(value)}</span>;
  }

  /**
   * A VALUE NEVER UNDERLINES UNDER THE POINTER (wave 3, owner finding H-C2). The accent
   * colour and the cursor already say it is a link; an underline appearing on hover is a
   * web document's convention, and Apple's list feedback is reserved for SELECTION.
   * hig: https://developer.apple.com/design/human-interface-guidelines/lists-and-tables
   * The same rule holds for `EmailDisplay`, `PhoneDisplay` and `RelationDisplay`, which is
   * why all four lost the class in one change: the four render in a record row, in a table
   * cell and in the identity band, and the band's Website link is the one the owner hovered.
   */
  return (
    <a
      href={value}
      target="_blank"
      rel="noreferrer noopener"
      className="inline-flex min-w-0 items-center gap-1 text-accent"
      onClick={stopCellClick}
    >
      <span className="truncate">{formatUrl(value)}</span>
      <Icon name="external" size="0.75rem" />
    </a>
  );
}
